// removed by extract-text-webpack-plugin
module.exports = {"activities":"_1VyGpa8MBf2o0Z_4SpMSfp","message":"_32Z6BUzi14pMPXVvpGCjsy"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0936d728","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./~/vue-components/live-coach/components/live-coach.less
// module id = pqVL
// module chunks = 1